import React from 'react'
import { Upload, Button } from 'antd'
import loadImage from 'blueimp-load-image'

const signatureUri = process.env.REACT_APP_UPLOAD_SIGNATURE_URI
const s3signatureUri = process.env.REACT_APP_S3_UPLOAD_SIGNATURE_URI

const providerURIs = {
  gs: signatureUri,
  s3: s3signatureUri
}


/* ================================
   Resize only image files
================================ */
const resizeImg = async (file, { width, height }) => {
  return new Promise((resolve, reject) => {
    loadImage(
      file,
      canvas => {
        if (canvas.type === 'error') {
          reject(new Error('Incorrect Image'))
          return
        }

        canvas.toBlob(
          blob => {
            const result = new File([blob], file.name, {
              type: file.type,
              lastModified: Date.now()
            })
            resolve(result)
          },
          file.type,
          1
        )
      },
      {
        maxWidth: width,
        maxHeight: height,
        contain: true,
        orientation: true,
        canvas: true
      }
    )
  })
}

class CloudUploader extends React.Component {
  state = {
    loading: false
  }

  /* ================================
     Handle Upload Status
  ================================= */
  handleChange = ({ file }) => {
    const { onChange } = this.props

    if (file.status === 'uploading') {
      this.setState({ loading: true })
    }

    if (file.status === 'done') {
      const { fileUrl } = file.response
      onChange(fileUrl)
      this.setState({ loading: false })
    }

    if (file.status === 'error') {
      this.setState({ loading: false })
    }
  }

  /* ================================
     Upload to Signed URL
  ================================= */
  customRequest = async ({
    file,
    onError,
    onProgress,
    onSuccess
  }) => {
    try {
      let uploadFile = file
      const { maxDimension, provider = 'gs', object } = this.props

      // ✅ Resize only image files
      if (maxDimension && file.type.startsWith('image/')) {
        uploadFile = await resizeImg(file, {
          width: maxDimension,
          height: maxDimension
        })
      }

      const uri = providerURIs[provider]
      const extraQuery = object ? `&object=${object}` : ''

      const res = await fetch(
        `${uri}?mimetype=${uploadFile.type}${extraQuery}`,
        { method: 'POST' }
      )

      const { signedUrl, fileUrl } = await res.json()

      const xhr = new XMLHttpRequest()
      xhr.open('PUT', signedUrl, true)

      xhr.onprogress = ({ loaded, total }) => {
        if (total > 0) {
          onProgress({
            percent: Math.round((loaded / total) * 100)
          })
        }
      }

      xhr.onload = () => {
        if (xhr.status === 200) {
          onSuccess({ fileUrl }, uploadFile)
        } else {
          onError('Upload failed')
        }
      }

      xhr.onerror = () => {
        onError('Upload error')
      }

      xhr.setRequestHeader('Content-Type', uploadFile.type)

      if (provider === 'gs') {
        xhr.setRequestHeader('x-goog-acl', 'public-read')
      }

      xhr.send(uploadFile)
    } catch (err) {
      console.error(err)
      onError('Upload error')
    }
  }

  /* ================================
     Render Preview
  ================================= */
  renderPreview = value => {
    if (!value) return null

    const isImage = value.match(/\.(jpeg|jpg|gif|png|webp)$/i)

    if (isImage) {
      return <img src={value} alt="preview" style={{ width: 300 }} />
    }

    return (
      <div style={{ marginTop: 10 }}>
        <a href={value} target="_blank" rel="noopener noreferrer">
          📎 View Uploaded File
        </a>
      </div>
    )
  }

  /* ================================
     Render
  ================================= */
  render() {
    const { value, accept } = this.props
    const { loading } = this.state

    return (
      <div>
        <Upload
          accept={accept}   // ถ้าไม่ส่ง accept มา = อัปโหลดได้ทุกไฟล์
          onChange={this.handleChange}
          customRequest={this.customRequest}
          showUploadList={false}
        >
          {loading ? (
            <Button disabled icon="loading">
              Uploading...
            </Button>
          ) : (
            <Button icon="upload">Upload</Button>
          )}
        </Upload>

        {this.renderPreview(value)}
      </div>
    )
  }
}

export default CloudUploader